import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "../axios-Instance";
import { queryKeys } from "../react-query/constants";
import { getLoginToken } from "../storage";

async function getFastTrack() {
  const data = await axiosInstance({
    url: "/fasttrack",
    method: "GET",
    // headers: {
    //   Authorization: `Bearer ${getLoginToken()}`,
    // },
  });

  return data?.data?.data;
}

async function deleteFastTrack(id) {
  const data = await axiosInstance({
    url: `/fasttrack/${id}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

export function useFastTrack() {
  const fallback = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.fastTrack],
    queryFn: getFastTrack,
  });
  return data;
}

export function useDeleteFastTrack() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (id) => deleteFastTrack(id),
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.fastTrack]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}
